import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconInterview$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconInterview extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4bb219bb1bc2893c990b60a826bb116f6e29f756', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '4f3cd3545fb5f344d82da2779a085369545f018c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8dbec6b75a4aeab8a8cef7494bc1edff0c3665a0', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 2h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H14a.5.5 0 0 1-.5-.5v-1h-10v6H5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.11.28l-.83 1a.33.33 0 0 1-.26.14.31.31 0 0 1-.3-.31V11H2.5a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5m4.98 13.5v-8A.5.5 0 0 1 8 7h11.52a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-1.5v3.29a.3.3 0 0 1-.51.22L13.91 16H8a.5.5 0 0 1-.52-.5m9.52-1h1.48l.02-6H9v6h5.29a.47.47 0 0 1 .35.15l1.86 1.85V15a.5.5 0 0 1 .5-.5", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-interview", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-interview"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-interview":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconInterview$1);
            }
            break;
    } });
}

const CosmosIconInterview = CosmosIconInterview$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconInterview, defineCustomElement };
